import React from "react";
import Select from "react-select";
import styles from "./style.module.css";
import { selectOnChangeWrapper } from "utils/select";
export const DateInput = ({ label, labelIconColor, labelStyle, startDate, endDate, updateStartDate, updateEndDate, dateOptions, isDisabled, isSense }) => {
    return (React.createElement("div", { className: styles.KPIDateInputWrapper },
        React.createElement("div", { className: styles.KPIDateInputLabel, style: labelStyle },
            labelIconColor !== undefined && (React.createElement("div", { className: styles.KPIDateColorIcon, style: {
                    backgroundColor: labelIconColor
                } })),
            React.createElement("div", { className: styles.KPIDateLabel }, label)),
        React.createElement("div", { className: styles.KPIDateInput },
            React.createElement("div", { className: styles.KPIDateInputSelection },
                React.createElement(Select, { value: dateOptions.find((o) => o.value === startDate), onChange: selectOnChangeWrapper(updateStartDate), options: dateOptions, isSearchable: true, isDisabled: isDisabled, styles: {
                        menuList: (provided) => ({
                            ...provided,
                            maxHeight: isSense ? "180px" : "160px"
                        })
                    } })),
            React.createElement("div", { className: styles.KPIDateInputText }, "to"),
            React.createElement("div", { className: styles.KPIDateInputSelection },
                React.createElement(Select, { value: dateOptions.find((o) => o.value === endDate), onChange: selectOnChangeWrapper(updateEndDate), options: dateOptions, isSearchable: true, isDisabled: isDisabled, styles: {
                        menuList: (provided) => ({
                            ...provided,
                            maxHeight: isSense ? "180px" : "160px"
                        })
                    } })))));
};
export default DateInput;
